import { FC } from 'react';
import { Grid } from '@mui/system';
import { InlineMessageBox } from 'components';
import useStyles from './styles';
import { InformationMessageProps } from './types';

const InformationMessage: FC<InformationMessageProps> = props => {
  const { displayMessage, message, noMargin } = props;

  const classes = useStyles();

  return (
    <>
      {displayMessage && (
        <Grid className={classes.messageContainer} size={{ xs: 12 }}>
          <InlineMessageBox noMargin={noMargin} text={message} />
        </Grid>
      )}
    </>
  );
};

export default InformationMessage;
